module.exports = __webpack_public_path__ + "media/images/webpage/coupons/new_registration/howto-card-d9ea6f0cf51b89201be9ab62e554e2ae.webp";